/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { checkIsFraud } from '@eisinc/App/Services/CheqService';
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect } from "react-redux";

const enum fields {
    threatTypeCodeCommaSeperated = "threatTypeCodeCommaSeperated",
}

interface CheqProtectionProps extends WidgetProps {
    fields: {
        [fields.threatTypeCodeCommaSeperated]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        location: getLocation(state),
        cheqProtectionPageLink: getPageLinkByPageType(state, "CheqProtection")?.url || "/CheqProtection",
    };
};

type Props = CheqProtectionProps & HasHistory & ReturnType<typeof mapStateToProps>;

export interface CheqProtectionStyles {
}

export const CheqProtectionStyles: CheqProtectionStyles = {
};

const styles = CheqProtectionStyles;

class CheqProtectionWidget extends React.Component<Props> {
    componentDidMount = () => {
        this.onRouteChanged();    
    }

    onRouteChanged = () => {
        const threatTypeCodeArray = this.props.fields?.threatTypeCodeCommaSeperated?.split(',');
        const arrOfNum = threatTypeCodeArray.map(element => {
            return Number(element);
        });
        const parameter = {
            "EventType": "page_load",
            "ThreatTypeCode": arrOfNum,
            Host: window.location.host,
            RequestUrl: window.location.href,
            UserAgent: navigator.userAgent,
            AcceptLanguage: navigator.language,
            Connection:'keep-alive',
            Accept:'*/*',
            CacheControl:'max-age=0',
        };

        checkIsFraud(parameter).then(
            (response: any) => {
                if(response.isFraud) {
                    this.redirectToCustomPage();
                }
            },
            (error: any) => {

            }
        )
    }

    redirectToCustomPage = () => {
        this.props.history.push(this.props.cheqProtectionPageLink);
    }

    render = () => {
        return (
            <>
            </>
        );
    }
}

export const definition: WidgetDefinition = {
    group: "Xngage Custom" as any,
    fieldDefinitions: [
        {
            name: fields.threatTypeCodeCommaSeperated,
            displayName: "Allowed Threat Type Codes Comma Seperated",
            editorTemplate: "TextField",
            defaultValue: "1,2",
            fieldType: "General",
            isRequired: true,
            regularExpression: new RegExp("^[0-9]+(,[0-9]+)*$"),
        },
    ],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(CheqProtectionWidget)),
    definition,
};

export default widgetModule;
